import { P2GMenuList, P2GBox } from '@parcel2go/core-ui';
import { ReactNode, useState } from 'react';

export interface props {
  control: ReactNode;
  p?: number;
  pt?: number;
  pb?: number;
  pl?: number;
  pr?: number;
  onOpen?: () => void;
  onClose?: () => void;
  width?: string;
  children: ReactNode;
}

const P2GContentDropDown: React.FC<props> = (props) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    if (props.onOpen) {
      props.onOpen();
    }
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (props.onClose) {
      props.onClose();
    }
  };

  return (
    <>
      <span onClick={handleClick}>{props.control}</span>
      {open && (
        <P2GMenuList
          open={open}
          onClose={handleClose}
          anchorRef={anchorEl}
          style={{ width: 'auto', maxWidth: props.width, zIndex: 3 }}
        >
          <P2GBox textAlign="left" pl={props.pl || 2} pr={props.pr || 2} pt={props.pt} pb={props.pb}>
            {open && props.children}
          </P2GBox>
        </P2GMenuList>
      )}
    </>
  );
};

export default P2GContentDropDown;
